import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FormDataReader {
  readFileAsBase64(template: FormData): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      if (template) {
        const file = template.get('file[]') as File;
        let fileResult: string | ArrayBuffer | null = null;
        reader.readAsDataURL(file);
        reader.addEventListener(
          'load',
          function () {
            fileResult = reader.result;
          },
          false
        );

        reader.onloadend = (): void => {
          if (fileResult && typeof fileResult === 'string') {
            const fileBase64 = fileResult.split('base64,')[1];
            resolve(fileBase64 ?? '');
          } else {
            reject('Unable to read file');
          }
        };
      } else {
        resolve('');
      }
    });
  }
}
